module.exports = __webpack_public_path__ + "static/media/beyond_all_reason_logo.29019099.png";